<template>
  <div class="mb-[16px]">
    <label
      for="gambar-gudang"
      class="text-[14px] mb-[8px] text-[#626262]"
    >Gambar Gudang</label>

    <div
      :class="{'text-[#333333] p-[12px] rounded-[8px] border border-[#E2E2E2] flex items-start flex-wrap gap-[24px] max-h-[260px] overflow-y-auto': true,
               'bg-[#F4F4F4]': enableEditInput,
               'bg-[#FFFFFF]': !enableEditInput,
      }"
    >
      <input
        ref="fileInput"
        name="gambar-gudang"
        type="file"
        accept="image/jpeg, image/png, image/jpg, image/svg"
        hidden
        @change="onChangeFileImage"
      >
      <div>
        <button
          type="button"
          class="my-[4px] mx-auto size-[56px] flex items-center justify-center gap-[16px] border-dashed border-[2px] border-[#E2E2E2] bg-[#F8F8F8] transition-all duration-300 rounded-[8px] p-[4px]"
          :class="{'cursor-pointer hover:bg-[#FFFFFF]': !enableEditInput}"
          :disabled="enableEditInput"
          @click="handleAddImage"
        >
          <span class="k-add text-[24px]" />
        </button>
        <p class="text-[#828282] mb-0">
          Tambah Gambar
        </p>
      </div>
      <div
        v-for="(image, index) in polishedImages"
        :key="`${index}-${image.url}-warehouse-image`"
        class="relative w-fit p-[4px]"
      >
        <b-img
          :src="image"
          alt="logo"
          width="56"
          height="56"
          @error="handleImageError"
        />
        <button
          type="button"
          class="absolute top-0 right-0 hover:bg-[#FFFFFF] rounded-[8px] size-[16px]"
          :disabled="enableEditInput"
          @click="handleRemoveImage(index)"
        >
          <span class="k-close-circle" />
        </button>
      </div>
    </div>

    <small
      v-if="errorMessage"
      class="text-danger"
    >{{ errorMessage }}</small>
  </div>
</template>

<script>
import { MAX_IMAGE_WAREHOUSE_DISPLAYED } from '../config'

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    enableEditInput: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      MAX_IMAGE_WAREHOUSE_DISPLAYED,
      polishedImages: [],
      errorMessage: '',
    }
  },
  computed: {
    totalImagesNotVisible() {
      return {
        count: this.polishedImages.length - MAX_IMAGE_WAREHOUSE_DISPLAYED,
        show: this.polishedImages.length - MAX_IMAGE_WAREHOUSE_DISPLAYED > 0,
        thumbnail: this.polishedImages[MAX_IMAGE_WAREHOUSE_DISPLAYED],
      }
    },
  },
  watch: {
    form(newVal) {
      if (!newVal.image_warehouse) return
      const images = newVal.image_warehouse.map(image => image.image_url)
      this.polishedImages = images
    },
    polishedImages(newVal) {
      this.validate()
    },
  },
  created() {
    this.rawImages = []
    this.deletedImages = []
  },
  methods: {
    /**
     * Handle the add image so can be applied to the form
     */
    handleAddImage() {
      this.$refs.fileInput.click()
    },
    refreshImages() {
      this.rawImages = []
      this.deletedImages = []
    },
    onChangeFileImage(event) {
      const file = event.target.files[0]
      if (file.size > 10 * 1024 * 1024) {
        this.errorMessage = 'Gambar Gudang harus kurang dari 10MB'
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.polishedImages = [reader.result, ...this.polishedImages]
        this.rawImages = [file, ...this.rawImages]
      }
      reader.readAsDataURL(file)
    },
    /**
     * Handle the image error so can be applied to the form
     * @param {Event} event - The event
     */
    handleImageError(event) {
      const fallbackSrc = 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
      const imgElement = event.target
      imgElement.src = fallbackSrc
    },
    /**
     * Handle the remove image so can be applied to the form
     * @param {Number} index - The index
     */
    handleRemoveImage(index) {
      const rawLength = this.rawImages?.length ?? 0
      if (rawLength > 0 && index < rawLength) {
        this.rawImages.splice(index, 1)
      } else {
        this.deletedImages.push(this.polishedImages[index])
      }
      this.$delete(this.polishedImages, index)
    },
    /**
     * Manually validate the image so can be applied to the form
     * @returns {Object} The validate
     */
    validate() {
      const isValid = this.polishedImages.length > 0

      if (!isValid) {
        this.errorMessage = 'Gambar Gudang harus diisi'
        return {
          isValid: false,
          data: {
            new: null,
            deleted: null,
          },
        }
      }
      this.errorMessage = ''
      return {
        isValid: true,
        data: {
          new: this.rawImages,
          deleted: this.deletedImages,
        },
      }
    },
  },
}
</script>
